(() => {
  if (window.amOverlandPreorderMounted) return;
  window.amOverlandPreorderMounted = true;
  function update(page, preorder, available, distributor) {
    const notice = page?.querySelector('[data-product-preorder]');
    if (!notice) return;
    const fromDistributor = distributor ?? notice.dataset.distributorPreorder === 'true';
    preorder = fromDistributor || preorder;
    notice.hidden = !preorder;
    const button = page.querySelector('[data-add-button]');
    if (available && button && !button.disabled) button.querySelector('span').textContent = 'ADD TO BAG';
  }
  function fromSelect(select) {
    const page = select.closest('.product-page');
    const data = page?.querySelector('[data-preorder-variants]');
    if (!data) return;
    const states = JSON.parse(data.textContent);
    const option = select.selectedOptions[0];
    update(page, states[select.value] === true, option?.dataset.available === 'true');
  }
  function mount() {
    document.querySelectorAll('[data-variant-select]').forEach(fromSelect);
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) fromSelect(event.target);
  });
  document.addEventListener('am:configuration-state', event => {
    update(event.target.closest('.product-page'), event.detail.preorder === true, event.detail.available === true, event.detail.distributor_preorder);
  });
  document.addEventListener('shopify:section:load', mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
